import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
import { cn } from '@/lib/utils';
import * as Dialog from '@radix-ui/react-dialog';
import { TypeEnabaleBtn } from './types/AdmissionType';
import FormRegister from '../auth/FormRegister';
import { CiCircleRemove } from 'react-icons/ci';
import { setSelectedTurn } from '@/lib/RTK/features/AdmissionSlice';
import { useRouter } from 'next/navigation';
import { formatNameDoctor } from '@/constant/scripts';
import { logout } from '@/lib/RTK/features/AuthSlice';
import { Button } from '@/components/ui/button';

const FormTurnModal = (props: TypeEnabaleBtn) => {
    const {
        enableSubmit,
        handleResetPosition,
        textBtn,
        docid, 
        docname,
        buttonElement,
    } = props;

    const selectedTurn = useAppSelector((s) => s.admission.currentTurnTimeDate);
    const router = useRouter();
    const dispatch = useAppDispatch();

    const updatedClinicId = useAppSelector(
        (state) => state.admission.updateClinicId,
    );

    const hanldeSendToPage = () => {
        dispatch(
            setSelectedTurn({
                date:
                    selectedTurn?.date || props.timeTurnfirst?.first_date || '',
                time:
                    selectedTurn?.time || props.timeTurnfirst?.first_time || '',
                jalali: selectedTurn?.jalali,
                childId: '0',
            }),
        );
        router.push(
            `/doctor/${docid}/${formatNameDoctor(
                docname,
            )}/${updatedClinicId}/turn`,
        );
    };

    return (
        <Dialog.Root
            defaultOpen={true}
            onOpenChange={(open) => {
                if (!open) {
                    dispatch(logout());

                    handleResetPosition();
                }
            }}
        >
            <Dialog.Trigger disabled={!enableSubmit} asChild>
                {buttonElement ? (
                    buttonElement
                ) : (
                    <Button variant={'blue'}>
                        {textBtn ? 'درخواست نوبت' : 'تکمیل فرم نوبت'}
                    </Button>
                )}
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-[#0000002b] opacity-100" />
                <Dialog.Content className={cn('', styleContent)}>
                    <Dialog.Title className="flex items-center gap-3 sm:!pt-0 pt-3 pb-5 font-bold text-[17px] justify-center text-black">
                        لطفا اطلاعات خود را تکمیل کنید
                    </Dialog.Title>

                    <div className="flex_col gap-6 items-center">
                        <fieldset className="flex_center w-full">
                            <FormRegister
                                className="!grid md:!grid-cols-2 w-full !items-end"
                                redirecTbHomePlus={false}
                                inputStyles="p-2 border-gray-300"
                                onSuccess={hanldeSendToPage}
                            />
                        </fieldset>
                    </div>
                    <Dialog.Close asChild>
                        <button className={cn('', styleBtn)} aria-label="Close">
                            <CiCircleRemove />
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default FormTurnModal;

const styleContent =
    '!rounded-2xl data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] h-auto lg: max-h-[85vh] md:!overflow-y-hidden overflow-y-scroll w-[90vw] max-w-[700px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none ';

const styleBtn =
    'font-bold text-2xl hover:bg-violet4 focus:shadow-violet7 absolute top-[10px] left-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none';
